<template>
  <div class="unauthorized">
    <div class="container">
      <div class="error-content">
        <h1>403</h1>
        <h2>Access Denied</h2>
        <p>You don't have permission to access this page.</p>
        <router-link to="/" class="btn btn-primary">
          Go to Dashboard
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Unauthorized'
}
</script>

<style scoped>
.unauthorized {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
}

.error-content {
  text-align: center;
}

.error-content h1 {
  font-size: 120px;
  color: #dc3545;
  margin-bottom: 20px;
}

.error-content h2 {
  color: #333;
  margin-bottom: 20px;
}

.error-content p {
  color: #666;
  margin-bottom: 30px;
  font-size: 18px;
}
</style>